import React, { useCallback, useEffect, useRef, useState } from 'react';
import { notificationAPI } from '../../api/api';
import './YatayKaydirma.css';

/*
  YANA KAYAN TABLO KUTUSU

  Telefonda genis bir tablo (dosya detayindaki belgeler) bu kutunun
  icinde yana kayar. Kullanici iPhone uygulamasinda parmakla yana
  kaydiramadigini bildirdi; tarayici benzetiminde kutu kaymaya uygun
  gorunuyordu, yani engel telefona ozgu.

  Bu yuzden iki sey var:
  1. Ustte ◀ ▶ dugmeleri: parmak hareketinden bagimsiz, her durumda
     tabloyu kaydirir. Yalnizca tablo ekrana sigmiyorsa gorunur.
  2. TESHIS: uygulamada ilk yana surme hareketinde kutunun olculeri,
     hareketin kutuyu kaydirip kaydirmadigi ve parmagin altindaki oge
     sunucu kaydina yaziliyor (oturum basina bir kez). Sebebi tahmin
     etmek yerine telefonun kendisinden ogreniyoruz.
*/

const uygulamada = () => {
  try { return document.body.classList.contains('capacitor-native'); } catch (e) { return false; }
};

let teshisGonderildi = false;
let baslangicGonderildi = false;

/* Parmagin altindaki ogeden yukari: hareketi kisitlayabilecek her ata
   (touch-action auto degil ya da tasma ayari olan). Ilk yana surmede hic
   kayit gelmedi; dokunusun kutuya ulasip ulasmadigini ve neyin ustunden
   gectigini gormek icin. */
const zincir = (oge) => {
  const parcalar = [];
  for (let e = oge; e && e !== document.documentElement; e = e.parentElement) {
    const st = getComputedStyle(e);
    if (st.touchAction !== 'auto' || st.overflowX !== 'visible' || st.position === 'fixed') {
      const ad = String(e.className || '').split(' ')[0].slice(0, 24);
      parcalar.push(`${e.tagName.toLowerCase()}.${ad}:${st.touchAction}/${st.overflowX}/${st.position}`);
    }
  }
  return parcalar.join(' > ').slice(0, 600);
};

const YatayKaydirma = ({ className = '', children }) => {
  const kutu = useRef(null);
  const [durum, setDurum] = useState({ tasiyor: false, sol: false, sag: false });

  const olc = useCallback(() => {
    const k = kutu.current;
    if (!k) return;
    const tasiyor = k.scrollWidth > k.clientWidth + 4;
    setDurum({
      tasiyor,
      sol: tasiyor && k.scrollLeft > 4,
      sag: tasiyor && k.scrollLeft + k.clientWidth < k.scrollWidth - 4,
    });
  }, []);

  useEffect(() => {
    const k = kutu.current;
    if (!k) return undefined;
    olc();
    k.addEventListener('scroll', olc, { passive: true });
    window.addEventListener('resize', olc);
    let gozlemci = null;
    if (typeof ResizeObserver === 'function') {
      gozlemci = new ResizeObserver(olc);
      gozlemci.observe(k);
      if (k.firstElementChild) gozlemci.observe(k.firstElementChild);
    }
    return () => {
      k.removeEventListener('scroll', olc);
      window.removeEventListener('resize', olc);
      if (gozlemci) gozlemci.disconnect();
    };
  }, [olc]);

  // Teshis: yalnizca uygulamada, ilk belirgin yana surmede bir kez.
  useEffect(() => {
    const k = kutu.current;
    if (!k || !uygulamada()) return undefined;
    let bas = null;
    let engellenen = false;
    let son = null;

    const basla = (e) => {
      const t = e.touches && e.touches[0];
      if (!t) return;
      // Dinleyici belgede: kutunun ustunu gorunmez bir katman ortuyorsa
      // dokunus kutuya hic ulasmaz; bu da kayitta gorunsun (icinde=false).
      const c = k.getBoundingClientRect();
      if (t.clientX < c.left || t.clientX > c.right || t.clientY < c.top || t.clientY > c.bottom) {
        bas = null;
        return;
      }
      const alttaki = document.elementFromPoint(t.clientX, t.clientY);
      bas = {
        x: t.clientX, y: t.clientY, sol: k.scrollLeft,
        hedef: alttaki ? `${alttaki.tagName}.${String(alttaki.className || '').slice(0, 40)}` : '-',
        icinde: !!(alttaki && k.contains(alttaki)),
      };
      engellenen = false;
      son = null;
      if (!baslangicGonderildi) {
        baslangicGonderildi = true;
        notificationAPI.tani('belge-kaydirma',
          `basladi hedef=${bas.hedef} icinde=${bas.icinde} genislik=${k.clientWidth}/${k.scrollWidth} zincir=${zincir(alttaki)}`);
      }
    };
    const hareket = (e) => {
      if (e.defaultPrevented) engellenen = true;
      const t = e.touches && e.touches[0];
      if (t) son = { clientX: t.clientX, clientY: t.clientY };
    };
    // iOS hareketi baska bir kaydiriciya (sayfaya) verirse touchend yerine
    // touchcancel gelir; o da kaydediliyor.
    const bitti = (e) => {
      if (!bas || teshisGonderildi) return;
      const t = (e.changedTouches && e.changedTouches[0]) || son;
      if (!t) return;
      const b = bas;
      const dx = Math.round(t.clientX - b.x);
      const dy = Math.round(t.clientY - b.y);
      // Basit dokunus (dugmeye basma) kayda girmesin; iptal her zaman girer.
      if (e.type === 'touchend' && Math.abs(dx) < 20) return;
      teshisGonderildi = true;
      bas = null;
      const s = getComputedStyle(k);
      const metin = `olay=${e.type} dx=${dx} dy=${dy} kaydi=${k.scrollLeft - b.sol} genislik=${k.clientWidth}/${k.scrollWidth}`
        + ` ox=${s.overflowX} ta=${s.touchAction} engellendi=${engellenen}`
        + ` hedef=${b.hedef} icinde=${b.icinde} ekran=${window.innerWidth}`;
      notificationAPI.tani('belge-kaydirma', metin);
    };

    document.addEventListener('touchstart', basla, { passive: true });
    document.addEventListener('touchmove', hareket, { passive: true });
    document.addEventListener('touchend', bitti, { passive: true });
    document.addEventListener('touchcancel', bitti, { passive: true });
    return () => {
      document.removeEventListener('touchstart', basla);
      document.removeEventListener('touchmove', hareket);
      document.removeEventListener('touchend', bitti);
      document.removeEventListener('touchcancel', bitti);
    };
  }, []);

  /*
    PARMAKLA YANA KAYDIRMA (dokunmatik ekran)

    Telefonun kaydi kaniti: parmak kutuya ulasiyor, hicbir sey hareketi
    engellemiyor (dx=-158, engellendi=false), kutu kaymaya uygun
    (352/1046) ama iPhone uygulamasi kutuyu yine de kaydirmiyordu
    (kaydi=0). Oklarla programla kaydirma ise calisiyor.

    Bu yuzden yatay hareketi iPhone'a birakmiyoruz: kutuya
    "touch-action: pan-y" verilip dikey kaydirma telefonda kaliyor, yatay
    hareketi biz izleyip scrollLeft'i parmakla birlikte yuruyoruz;
    birakinca hiza gore yavaslayarak devam ediyor.
  */
  const dokunmatik = typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia('(pointer: coarse)').matches;

  useEffect(() => {
    const k = kutu.current;
    if (!k || !dokunmatik) return undefined;

    let x0 = 0;
    let y0 = 0;
    let sol0 = 0;
    let yon = null;          // null | 'yatay' | 'dikey'
    let izler = [];          // son hareketler: hiz hesabi icin
    let kare = null;

    const durdur = () => { if (kare) { cancelAnimationFrame(kare); kare = null; } };

    const basla = (e) => {
      const t = e.touches && e.touches[0];
      if (!t || e.touches.length > 1) { yon = 'dikey'; return; }
      durdur();
      x0 = t.clientX;
      y0 = t.clientY;
      sol0 = k.scrollLeft;
      yon = null;
      izler = [{ x: t.clientX, z: performance.now() }];
    };

    const hareket = (e) => {
      const t = e.touches && e.touches[0];
      if (!t || yon === 'dikey') return;
      const dx = t.clientX - x0;
      const dy = t.clientY - y0;
      if (yon === null) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        yon = Math.abs(dx) > Math.abs(dy) ? 'yatay' : 'dikey';
        if (yon === 'dikey') return;
      }
      // Yatay surerken sayfa dikeyde oynamasin.
      if (e.cancelable) e.preventDefault();
      k.scrollLeft = sol0 - dx;
      const simdi = performance.now();
      izler.push({ x: t.clientX, z: simdi });
      while (izler.length > 2 && simdi - izler[0].z > 100) izler.shift();
    };

    const bitti = () => {
      if (yon !== 'yatay' || izler.length < 2) { yon = null; return; }
      yon = null;
      const ilk = izler[0];
      const sonIz = izler[izler.length - 1];
      const sure = Math.max(1, sonIz.z - ilk.z);
      let hiz = -(sonIz.x - ilk.x) / sure; // px / ms
      if (Math.abs(hiz) < 0.05) return;
      let onceki = performance.now();
      const adim = (simdi) => {
        const gecen = simdi - onceki;
        onceki = simdi;
        k.scrollLeft += hiz * gecen;
        hiz *= Math.pow(0.95, gecen / 16);
        const kenarda = k.scrollLeft <= 0 || k.scrollLeft + k.clientWidth >= k.scrollWidth - 1;
        kare = Math.abs(hiz) > 0.02 && !kenarda ? requestAnimationFrame(adim) : null;
      };
      kare = requestAnimationFrame(adim);
    };

    k.addEventListener('touchstart', basla, { passive: true });
    k.addEventListener('touchmove', hareket, { passive: false });
    k.addEventListener('touchend', bitti, { passive: true });
    k.addEventListener('touchcancel', bitti, { passive: true });
    return () => {
      durdur();
      k.removeEventListener('touchstart', basla);
      k.removeEventListener('touchmove', hareket);
      k.removeEventListener('touchend', bitti);
      k.removeEventListener('touchcancel', bitti);
    };
  }, [dokunmatik]);

  const kaydir = (yon) => {
    const k = kutu.current;
    if (!k) return;
    k.scrollBy({ left: yon * Math.max(160, k.clientWidth * 0.8), behavior: 'smooth' });
  };

  return (
    <>
      {durum.tasiyor && (
        <div className="yk-dugmeler">
          <span className="yk-ipucu">Tablonun devamı sağda</span>
          <button type="button" className="yk-dugme" onClick={() => kaydir(-1)}
                  disabled={!durum.sol} aria-label="Sola kaydır">◀</button>
          <button type="button" className="yk-dugme" onClick={() => kaydir(1)}
                  disabled={!durum.sag} aria-label="Sağa kaydır">▶</button>
        </div>
      )}
      <div ref={kutu} className={className} style={dokunmatik ? { touchAction: 'pan-y' } : undefined}>
        {children}
      </div>
    </>
  );
};

export default YatayKaydirma;
